import React, { useState } from 'react';

interface NumberGridProps {
  value: string;
  maxDigits: number;
  onChange: (value: string) => void;
}

export const NumberGrid: React.FC<NumberGridProps> = ({ value, maxDigits, onChange }) => {
  const [showGrid, setShowGrid] = useState(true);

  // For 2-digit sorteos, show 00-99 grid. For others, show only manual input.
  const isGridMode = maxDigits === 2;

  const handleGridSelect = (num: string) => {
    onChange(num);
  };

  const handleManualChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value.replace(/\D/g, '').slice(0, maxDigits);
    onChange(v);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <p className="text-white font-bold text-base">Elige tu numero</p>
        {isGridMode && (
          <button
            type="button"
            onClick={() => setShowGrid(!showGrid)}
            className="text-xs text-blue-400 hover:text-blue-300"
          >
            {showGrid ? 'Escribir manual' : 'Ver cuadricula'}
          </button>
        )}
      </div>
      <p className="text-gray-500 text-xs -mt-1">
        Selecciona un numero del {'0'.repeat(maxDigits)} al {'9'.repeat(maxDigits)}
      </p>

      {isGridMode && showGrid ? (
        <div className="grid grid-cols-10 gap-1">
          {Array.from({ length: 100 }, (_, i) => {
            const num = i.toString().padStart(2, '0');
            const isSelected = value === num;
            return (
              <button
                key={num}
                type="button"
                onClick={() => handleGridSelect(num)}
                className={`aspect-square flex items-center justify-center rounded-lg text-sm font-bold transition-all ${
                  isSelected
                    ? 'bg-blue-600 text-white ring-2 ring-blue-400 scale-105'
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700 active:bg-gray-600 border border-gray-700'
                }`}
              >
                {num}
              </button>
            );
          })}
        </div>
      ) : (
        <input
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={maxDigits}
          value={value}
          onChange={handleManualChange}
          className="w-full bg-gray-800 text-white text-4xl font-mono rounded-xl px-5 py-4 border-2 border-gray-700 focus:border-blue-500 focus:outline-none text-center"
          placeholder={'0'.repeat(maxDigits)}
          autoFocus
        />
      )}
    </div>
  );
};
